import React from 'react';

import { ChatTyping } from '../../../../components/Chat/kit';

interface Props {
  // What Laila is doing, e.g. "Checking who's clocked in".
  label?: string;
  onStop?: () => void;
}

// Laila's "typing…" bubble while an answer is on its way.
export const LailaTyping: React.FC<Props> = ({ label, onStop }) => (
  <ChatTyping who="Laila" label={label} onStop={onStop} />
);
